import * as React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgScalesFilled = (props) => {
    const { color } = props;
    return (React.createElement(React.Fragment, null,
        React.createElement("path", { d: "M12 17a3 3 0 0 0 2.691-4.327l-1.57 1.57a1 1 0 1 1-1.414-1.415l1.552-1.552A3 3 0 1 0 12 17Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.686 6.622a22.962 22.962 0 0 1 4.314-.6V4H6a1 1 0 0 1 0-2h12a1 1 0 1 1 0 2h-5v2.022c1.45.063 2.895.263 4.314.6 1.762.42 3.078 1.82 3.318 3.532l1.35 9.63c.164 1.173-.796 2.216-2.04 2.216H4.058c-1.245 0-2.205-1.043-2.04-2.217l1.35-9.63c.24-1.712 1.554-3.112 3.317-3.53ZM12 19a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z", fill: color })));
};
export default factorySvgIcon(SvgScalesFilled);
//# sourceMappingURL=SvgScalesFilled.js.map